export { default as galleryPropTypes } from './galleryPropTypes';
export { default as galleryDefaultProps } from './galleryDefaultProps';
export { default as imagePropTypes } from './imagePropTypes';
export { default as imageDefaultProps } from './imageDefaultProps';
